export default "__VITE_ASSET__C69lP$MH__"